/* Complete by Dr SCS — shared site-wide behavior. Loaded once via theme.liquid.
   Replaces the old per-page "DC" component: real Shopify cart (AJAX), plain vanilla JS,
   scoped with querySelectorAll so it's safe no matter which sections are present. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Smoothly jump to an in-page anchor (e.g. mega menu links like /#how), including
     when the hash is present on initial page load (not just same-page hash clicks). */
  var scrollToHash = function (hash) {
    if (!hash || hash.length < 2) return;
    var target;
    try { target = document.getElementById(hash.slice(1)); } catch (e) { target = null; }
    if (!target) return;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  };
  if (window.location.hash) setTimeout(function () { scrollToHash(window.location.hash); }, 350);
  window.addEventListener('hashchange', function () { scrollToHash(window.location.hash); });

  /* Loading veil */
  var veil = document.querySelector('.veil');
  if (veil) setTimeout(function () { veil.style.display = 'none'; }, reduce ? 0 : 1900);

  /* Theme editor: sections are re-rendered over AJAX whenever a setting is
     focused or changed, so the reveal-on-scroll elements come back at opacity
     0 with no script run against them and the section looks blank. Inside the
     editor the animations are decoration with no audience, so they are
     disabled outright rather than re-wired to every editor event. */
  if (window.Shopify && Shopify.designMode) {
    var edStyle = document.createElement('style');
    edStyle.textContent = '.rv{opacity:1!important;transform:none!important;transition:none!important}' +
      '.veil,.cur,.curRing{display:none!important}';
    document.head.appendChild(edStyle);
  }

  /* Reveal-on-scroll */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.rv'));
  if (reduce) {
    revealEls.forEach(function (e) { e.classList.add('in'); });
  } else if ('IntersectionObserver' in window) {
    /* Driven by an observer rather than scroll events. Reloading the page part
       way down restores the scroll position without firing a scroll event, so
       the scroll-based version left anything already on screen stuck at opacity
       zero until the visitor happened to scroll again. */
    var revealIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        revealIo.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { revealIo.observe(el); });
  } else {
    var reveal = function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      revealEls.forEach(function (el) {
        if (el.classList.contains('in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > -40) el.classList.add('in');
      });
    };
    reveal();
    window.addEventListener('scroll', reveal, { capture: true, passive: true });
    window.addEventListener('resize', reveal);
    setTimeout(reveal, 180);
    setTimeout(reveal, 700);
  }

  /* Animated counters (data-count / data-suffix) */
  var animateCount = function (el) {
    var target = parseFloat(el.dataset.count);
    var suf = el.dataset.suffix || '';
    if (reduce || isNaN(target)) { if (!isNaN(target)) el.textContent = target + suf; return; }
    var dur = 1300, start = performance.now();
    var step = function (t) {
      var p = Math.min(1, (t - start) / dur);
      el.textContent = Math.round((1 - Math.pow(1 - p, 3)) * target) + suf;
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  if (document.querySelectorAll('[data-count]').length && 'IntersectionObserver' in window) {
    var ioc = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { animateCount(en.target); ioc.unobserve(en.target); } });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-count]').forEach(function (el) { ioc.observe(el); });
  }

  /* Magnetic buttons + 3D tilt cards + custom cursor (desktop, fine pointer only) */
  if (!reduce) {
    document.querySelectorAll('[data-mag]').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.22 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.32 + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = 'translate(0,0)'; });
    });
    document.querySelectorAll('[data-tilt]').forEach(function (c) {
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'perspective(900px) rotateY(' + px * 4 + 'deg) rotateX(' + (-py * 4) + 'deg)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = 'perspective(900px) rotateY(0) rotateX(0)'; });
    });
    var cur = document.querySelector('.cur'), ring = document.querySelector('.curRing');
    if (cur && ring && window.matchMedia('(pointer:fine)').matches) {
      var mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my;
      window.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; cur.style.transform = 'translate(' + mx + 'px,' + my + 'px)'; });
      (function loop() { rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18; ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)'; requestAnimationFrame(loop); })();
      var grow = function () { ring.style.width = '52px'; ring.style.height = '52px'; ring.style.margin = '-26px 0 0 -26px'; ring.style.borderColor = 'rgba(246,242,236,.9)'; };
      var shrink = function () { ring.style.width = '34px'; ring.style.height = '34px'; ring.style.margin = '-17px 0 0 -17px'; ring.style.borderColor = 'rgba(246,242,236,.6)'; };
      document.querySelectorAll('[data-cur],a,button,summary').forEach(function (el) { el.addEventListener('mouseenter', grow); el.addEventListener('mouseleave', shrink); });
    }
  }

  /* Header solid-on-scroll + reading progress bar */
  var header = document.querySelector('.hdr');
  var progEl = document.querySelector('[data-progress]');
  var onScroll = function () {
    var y = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (header) header.classList.toggle('solid', y > 40);
    if (progEl) {
      var max = (document.body.scrollHeight || document.documentElement.scrollHeight) - (window.innerHeight || 800);
      progEl.style.width = Math.max(0, Math.min(100, (y / (max || 1)) * 100)) + '%';
    }
  };
  window.addEventListener('scroll', onScroll, { capture: true, passive: true });
  onScroll();

  /* Mobile menu */
  var menu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-menu-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!menu) return;
      var open = menu.getAttribute('data-open') === 'true';
      menu.setAttribute('data-open', open ? 'false' : 'true');
      menu.style.transform = open ? 'translateX(100%)' : 'translateX(0)';
    });
  });
  // Close the mobile menu when any link inside it is tapped (in-page anchors otherwise leave it covering the page)
  if (menu) {
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.setAttribute('data-open', 'false');
        menu.style.transform = 'translateX(100%)';
      });
    });
  }

  /* ---- Real Shopify cart (AJAX Cart API) ---- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartBody = document.querySelector('[data-cart-body]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');
  // Scope subtotal updates to the drawer only, so the server-rendered /cart page total isn't overwritten
  var cartSubtotalEls = cartDrawer ? cartDrawer.querySelectorAll('[data-cart-subtotal]') : [];

  function money(cents) { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }); }

  /* A quarterly delivery is three months of supply bought as one commitment, so its
     quantity moves in whole deliveries. Left at single steps a shopper could drop the
     line to one unit and keep the quarterly discount, which is deeper than the monthly
     plan gives for that same single unit. */
  function lineStepFor(item) {
    var alloc = item.selling_plan_allocation;
    var name = alloc && alloc.selling_plan ? alloc.selling_plan.name : '';
    return name && /3 month|quarter/i.test(name) ? 3 : 1;
  }

  /* Itemised savings for the drawer, mirroring the basket page. Shopify reports one
     collapsed total, so each saving is derived here: rrp from the plan allocation's
     compare_at_price (the plan discount is baked into the line price), the plan price
     before the automatic discount - which is also the renewal figure - and the
     first-order discount itself. Nothing is hard coded, so it holds for any SKU. */
  var cartBreakdownEls = document.querySelectorAll('[data-cart-breakdown]');
  var cartRenewsEls = document.querySelectorAll('[data-cart-renews]');
  var giftWorth = (cartDrawer && cartDrawer.getAttribute('data-gift-value')) || '';

  function renderBreakdown(cart) {
    if (!cartBreakdownEls.length) return;
    var rrp = 0, planTotal = 0, firstOff = 0, renewEvery = '', showGift = false;
    /* Once the gift is a real basket line, naming it again in the summary reads as two gifts. */
    var giftLineInBasket = cart.items.some(function (i) { return isGiftVariant(i.variant_id) || (i.properties && i.properties._gift); });
    cart.items.forEach(function (item) {
      /* The gift is carried as a real line at its own price and written straight back off.
         Counting it here inflated "Full price" by the gift's worth and then reported the
         write-off as a first-order discount - on a basket with no subscription that read
         "Full price GBP162.80 / First order, 0% off -GBP44.00". It is neither a price the
         shopper would have paid nor a first-order discount, so it is left out of both. */
      if (isGiftVariant(item.variant_id) || (item.properties && item.properties._gift)) return;
      var alloc = item.selling_plan_allocation;
      var rrpEach = (alloc && alloc.compare_at_price) ? alloc.compare_at_price : item.original_price;
      rrp += rrpEach * item.quantity;
      firstOff += item.total_discount;
      if (alloc && alloc.selling_plan) {
        planTotal += item.final_line_price + item.total_discount;
        var n = alloc.selling_plan.name;
        if (/3 month|quarter/i.test(n)) {
          renewEvery = 'every 3 months';
          if (giftWorth && /system/i.test(item.handle || '')) showGift = true;
        } else if (/month/i.test(n)) {
          renewEvery = 'every month';
        }
      }
    });
    var subSaving = planTotal > 0 ? rrp - planTotal : 0;
    var saveToday = rrp - cart.total_price;
    var pct = function (part, whole) { return whole > 0 ? Math.round((part * 100) / whole) : 0; };

    var rows = '';
    function row(label, value, green) {
      rows += '<div style="display:flex;justify-content:space-between;gap:12px;padding:3px 0' +
        (green ? ';color:#3e7d5a' : '') + '"><span>' + label + '</span><span>' + value + '</span></div>';
    }
    /* Shown on every basket, not only a discounted one. A one-time purchase carries no
       discount at all, so without this the summary was nothing but a delivery line and a
       total. The gift is already left out of rrp, so this states what the shopper is
       actually buying - it never claims a saving that was not made. */
    if (rrp > 0) row('Full price' + (renewEvery === 'every 3 months' ? ' (3 months\u2019 supply)' : ''), money(rrp));
    if (subSaving > 0) row('Subscription saving, ' + pct(subSaving, rrp) + '%', '\u2212' + money(subSaving), true);
    /* A one-time basket has no plan total to measure the discount against, so the share is
       taken from what the shopper would otherwise pay. A share that rounds to nothing is
       never printed as "0% off" - the amount alone is the honest statement. */
    if (firstOff > 0) {
      var firstBase = planTotal > 0 ? planTotal : rrp;
      var firstPct = pct(firstOff, firstBase);
      row(firstPct > 0 ? 'First order, ' + firstPct + '% off' : 'First order discount', '\u2212' + money(firstOff), true);
    }
    row('UK delivery', '<strong style="color:#3e7d5a">FREE</strong>');
    // Display row only - the gift is a surprise, so it is never named here.
    if (showGift && !giftLineInBasket) row('Free gift <span style="color:#8a7c71">(worth ' + giftWorth + ')</span>', '<strong style="color:#3e7d5a">FREE</strong>');
    /* The two saving rows above are measured against different bases - the subscription
       saving off RRP, the first-order discount off the subscription price - so neither
       one is the headline figure the product page advertises. Their combined effect is,
       and it is this row: the share taken off RRP. Printing it here is what makes the
       basket agree with "50% off RRP" instead of appearing to contradict it. */
    if (saveToday > 0) {
      var savePct = pct(saveToday, rrp);
      row(savePct > 0 ? 'You save today, ' + savePct + '%' : 'You save today', money(saveToday), true);
    }
    cartBreakdownEls.forEach(function (el) { el.innerHTML = cart.item_count ? rows : ''; });
    // The renewal price has to be visible before purchase, not only in the email.
    cartRenewsEls.forEach(function (el) {
      if (!(cart.item_count && renewEvery && planTotal > 0)) { el.textContent = ''; return; }
      el.textContent = renewEvery === 'every 3 months'
        ? 'Then ' + money(planTotal) + ' every 3 months for your next 3-month supply. Skip or pause anytime.'
        : 'Then ' + money(planTotal) + ' ' + renewEvery + '. Skip or pause anytime.';
    });
  }

  function renderCart(cart) {
    cartCountEls.forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'flex' : 'none'; });
    cartSubtotalEls.forEach(function (el) { el.textContent = money(cart.total_price); });
    renderBreakdown(cart);
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div style="text-align:center;padding:60px 12px;color:#37322E"><p style="margin-bottom:18px">Your cart is empty</p><a href="/pages/shop" class="pri" style="display:inline-block;background:#1B1816;color:#fff;padding:12px 24px;border-radius:14px;font-size:.86rem;text-decoration:none">Return to shop</a></div>';
    } else {
      cartBody.innerHTML = cart.items.map(function (item, i) {
        var line = i + 1;
        /* The gift is placed and removed by the basket itself, so it carries no controls. */
        var isGift = isGiftVariant(item.variant_id) || !!(item.properties && item.properties._gift);
        var alloc = item.selling_plan_allocation || null;
        var planName = alloc && alloc.selling_plan ? alloc.selling_plan.name : '';
        var rrpEach = alloc && alloc.compare_at_price ? alloc.compare_at_price : item.original_price;
        var rrpLine = rrpEach * item.quantity;
        var lineSaved = rrpLine - item.final_line_price;
        /* A quarterly delivery ships one unit per month in a single parcel, so the
           quantity is months of supply. Without saying so the drawer reads as three
           separate purchases. */
        var supplyNote = (planName && /3 month/i.test(planName) && item.quantity > 1)
          ? item.quantity + ' months\u2019 supply, sent in one delivery' : '';
        var lineMax = 99;
        var lineStep = lineStepFor(item);
        var atMax = item.quantity + lineStep > lineMax;
        var downTo = item.quantity - lineStep;
        if (downTo < lineStep) downTo = 0;
        return '<div style="display:flex;gap:14px;padding:18px 0;border-bottom:1px solid rgba(27,24,22,.08)">' +
          (item.image ? '<img src="' + item.image + '" alt="" style="width:72px;height:84px;object-fit:cover;border-radius:10px;background:#eee">' : '<div style="width:72px;height:84px;border-radius:10px;background:rgba(222,215,204,.5)"></div>') +
          '<div style="flex:1;min-width:0">' +
          '<div style="display:flex;justify-content:space-between;gap:8px;align-items:flex-start">' +
          '<div style="font-family:\'Cormorant Garamond\',serif;font-size:1.1rem">' + item.product_title + '</div>' +
          (isGift ? '' : '<button type="button" data-cart-remove="' + line + '" aria-label="Remove item" style="background:none;border:0;cursor:pointer;color:#8a7c71;font-size:1.15rem;line-height:1;flex:0 0 auto">&times;</button>') +
          '</div>' +
          '<div style="font-size:.76rem;color:#B7AAA1;margin:2px 0 4px">' + (item.variant_title || '') + '</div>' +
          /* Shopify bakes a selling plan discount into the line price, so the cart
             reports no saving at all. The allocation carries the full price, which
             is what makes the discount visible here and on the cart page. */
          (planName ? '<div style="font-size:.74rem;color:#3e7d5a">' + planName + '</div>' : '') +
          (supplyNote ? '<div style="font-size:.72rem;color:#8a7c71">' + supplyNote + '</div>' : '') +
          '<div style="height:6px"></div>' +
          '<div style="display:flex;justify-content:space-between;align-items:center">' +
          /* A gift priced at zero has no struck-through price to show what it is worth,
             so the worth is said in words instead. */
          (isGift ? '<div style="font-size:.72rem;color:#8a7c71">Free gift' + (giftWorth && item.original_price === 0 ? ' <span style="color:#B7AAA1">(worth ' + giftWorth + ')</span>' : '') + '</div>' : '') +
          (isGift ? '' : '<div style="display:flex;align-items:center;border:1px solid rgba(27,24,22,.18);border-radius:10px;overflow:hidden">') +
          (isGift ? '' :
            '<button type="button" data-cart-chg="' + line + '" data-to="' + downTo + '" aria-label="Decrease quantity" style="width:30px;height:32px;background:none;border:0;cursor:pointer;font-size:1rem">&minus;</button>' +
            '<span style="width:28px;text-align:center;font-size:.85rem">' + item.quantity + '</span>' +
            '<button type="button" data-cart-chg="' + line + '" data-to="' + Math.min(lineMax, item.quantity + lineStep) + '"' + (atMax ? ' disabled' : '') + ' aria-label="Increase quantity" style="width:30px;height:32px;background:none;border:0;cursor:' + (atMax ? 'not-allowed' : 'pointer') + ';opacity:' + (atMax ? '.35' : '1') + ';font-size:1rem">+</button>' +
            '</div>') +
          '<div style="text-align:right">' +
          (lineSaved > 0 ? '<div style="font-size:.74rem;color:#8a7c71;text-decoration:line-through">' + money(rrpLine) + '</div>' : '') +
          '<span style="font-size:.9rem">' + money(item.final_line_price) + '</span>' +
          (lineSaved > 0 ? '<div style="font-size:.72rem;color:#3e7d5a">You save ' + money(lineSaved) + '</div>' : '') +
          '</div>' +
          '</div></div></div>';
      }).join('');
    }
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  // Drawer line quantity change / remove (line-based Cart AJAX API)
  function changeCart(line, qty) {
    /* Stepping one line up can still push the basket's monthly total over the
       ceiling even though each line is within its own, so the basket is settled
       again before it is drawn. */
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); })
      .then(function () { return settleBasket(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(renderCart).catch(function () {});
  }
  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var chg = e.target.closest && e.target.closest('[data-cart-chg]');
      var rm = e.target.closest && e.target.closest('[data-cart-remove]');
      if (chg) { changeCart(parseInt(chg.getAttribute('data-cart-chg'), 10), parseInt(chg.getAttribute('data-to'), 10)); }
      else if (rm) { changeCart(parseInt(rm.getAttribute('data-cart-remove'), 10), 0); }
    });
  }

  /* Every route into the basket - Add to Basket, the drawer stepper, the basket page -
     finishes here so the gift is re-decided against whatever the basket now holds. The
     checkout guard also waits on it, which is what stops a shopper reaching checkout
     with a gift the basket no longer earns. */
  function settleBasket() {
    return syncGift().catch(function () {});
  }

  /* ---- Free gift basket line ---------------------------------------------
     OPLOG picks and packs from the order's line items, so the gift has to arrive as a
     real line carrying its own SKU. A tag on the order is invisible to them. This puts
     the line in the basket; the store's "Buy X get Y" automatic discount is what makes
     it free. Keeping those two apart is deliberate: if this script never runs the
     shopper simply gets no gift, and if someone adds the capsules on their own they pay
     the full price, because the discount only fires next to a qualifying system.
     The line is re-read after it lands. If it did not come through at zero - a returning
     customer whose one gift is already spent, say - it is taken straight back out, so
     nobody is ever charged for something they were told was free. */
  var giftVariant = parseInt(cartDrawer && cartDrawer.getAttribute('data-gift-variant'), 10) || 0;
  var giftVariantAlt = parseInt(cartDrawer && cartDrawer.getAttribute('data-gift-variant-alt'), 10) || 0;
  var giftEligible = !cartDrawer || cartDrawer.getAttribute('data-gift-eligible') !== 'false';
  /* The gift product's own price, in pence. It is meant to be zero: a zero-priced gift
     needs no discount, so it is free in every basket, subscription included. If someone
     puts a price back on it the gift can only be zeroed by an automatic discount, and
     Shopify does not apply those to subscription baskets - the line would be charged in
     full. So the price itself decides whether a subscription basket may hold the line. */
  var giftPrice = parseInt(cartDrawer && cartDrawer.getAttribute('data-gift-price'), 10);
  if (isNaN(giftPrice)) giftPrice = 0;

  function isGiftVariant(id) {
    return id === giftVariant || (giftVariantAlt !== 0 && id === giftVariantAlt);
  }

  /* The basket earns the gift on what it is worth, not on which product is in it: the
     subtotal after discounts has to reach the threshold below. One-time purchases count,
     because the rule is about the order's value. The gift lines are left out of the sum so
     a gift can never help earn itself. Renewals never reach this code - the gift is a
     one-time line and is not part of the subscription contract, so it ships once and does
     not come back. The threshold comes from theme settings, in pence, so it can be changed
     without touching this file. */
  var giftThreshold = parseInt(cartDrawer && cartDrawer.getAttribute('data-gift-threshold'), 10);
  if (isNaN(giftThreshold) || giftThreshold < 0) giftThreshold = 5000;

  function basketEarnsGift(cart) {
    var qualifying = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (isGiftVariant(item.variant_id)) continue;
      qualifying += item.final_line_price;
    }
    return qualifying >= giftThreshold;
  }

  /* Matched on the variant alone, deliberately. The gift variant is not sold anywhere -
     it has no price and no route to it from the shop - so any line carrying it belongs to
     this script, whether it put it there or someone posted it to /cart/add.js by hand.
     Matching on the marker instead would leave a hand-posted line sitting in the basket
     untouched, which is exactly the hole this closes. */
  function giftLineIn(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftVariant(cart.items[i].variant_id)) {
        return { item: cart.items[i], line: i + 1 };
      }
    }
    return null;
  }

  /* Which gift this basket should get. Everyone is sent the Protect capsules, except a
     basket that already holds the Protect system AND the Protect capsules - that shopper
     would receive the same capsules twice, so theirs is swapped for the Clarify capsules.
     Returns 0 when the basket has not earned a gift at all. */
  function cartHasSubscription(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].selling_plan_allocation) return true;
    }
    return false;
  }

  function giftWantedFor(cart) {
    if (!basketEarnsGift(cart)) return 0;
    /* A priced gift can only be zeroed by an automatic discount, and Shopify does not
       apply those to subscription purchases - the line would be charged in full. So a
       priced gift stays out of a subscription basket and is carried as an order
       attribute for fulfilment plus the display row instead. A gift priced at zero
       needs no discount, so it goes in as a real line like any other product. */
    if (cartHasSubscription(cart) && giftPrice > 0) return 0;
    if (!giftVariantAlt) return giftVariant;
    var hasProtectSystem = false, hasProtectCapsules = false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (isGiftVariant(item.variant_id)) continue;
      var handle = item.handle || '';
      /* The client's wording is "ordered the protect system and the protect capsules" -
         no mention of a plan - and the gift itself no longer depends on subscribing, so
         neither does the swap. */
      if (handle === 'protect-system') hasProtectSystem = true;
      if (handle === 'protect-capsules') hasProtectCapsules = true;
    }
    return (hasProtectSystem && hasProtectCapsules) ? giftVariantAlt : giftVariant;
  }

  function addGift(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _gift: '1' } }] })
    }).then(giftMustBeFree);
  }

  /* Every gift line in the basket, not just the first. Someone posting both gift
     variants straight to /cart/add.js used to leave one behind, because a single pass
     only ever removed one line. */
  function giftLinesIn(cart) {
    var found = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftVariant(cart.items[i].variant_id)) found.push({ item: cart.items[i], line: i + 1 });
    }
    return found;
  }

  /* Removing a line renumbers every line below it, so the basket is read again before
     each removal rather than working from a list of numbers taken up front. One gift of
     the wanted kind is left alone; everything else goes, however many there are. */
  function dropUnwantedGifts(wanted) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var found = giftLinesIn(cart);
      var kept = false, target = null;
      for (var i = 0; i < found.length; i++) {
        if (wanted && !kept && found[i].item.variant_id === wanted) { kept = true; continue; }
        target = found[i];
        break;
      }
      if (!target) return;
      if (!wanted) giftNotice();
      return dropLine(target.line).then(function () { return dropUnwantedGifts(wanted); });
    });
  }

  function setLineQty(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    });
  }

  function dropLine(line) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    });
  }

  var giftNoticeShown = false;
  function giftNotice() {
    if (giftNoticeShown) return;
    giftNoticeShown = true;
    var n = document.createElement('div');
    n.setAttribute('role', 'alert');
    n.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
      'background:#1B1816;color:#F6F2EC;padding:14px 20px;border-radius:12px;font-size:.9rem;' +
      'max-width:min(92vw,480px);box-shadow:0 8px 30px rgba(0,0,0,.35);text-align:center';
    n.textContent = 'The free gift can\u2019t be added to the basket. It\u2019s included automatically with qualifying orders.';
    document.body.appendChild(n);
    setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); giftNoticeShown = false; }, 6000);
  }

  function giftMustBeFree() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var found = giftLineIn(cart);
      if (found && found.item.final_line_price > 0) { giftNotice(); return dropLine(found.line).then(fetchCartSafe); }
    });
  }

  function fetchCartSafe() { try { fetchCart(); } catch (e) {} }

  /* Fulfilment is told once, never twice. A zero-priced gift rides in the basket as a real
     line and is picked from its SKU like any other product, so the order attribute would be
     a second instruction for the same gift and could have it packed twice. The attribute is
     therefore only used while the gift is priced and so cannot be a line. */
  function setGiftAttribute(cart) {
    var want = (giftEligible && giftPrice > 0 && cartHasSubscription(cart) && basketEarnsGift(cart))
      ? 'YES - include free gift worth \u00a344' : '';
    var have = (cart.attributes && cart.attributes['Free gift']) || '';
    if (want === have) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Free gift': want } })
    }).catch(function () {});
  }

  function syncGift() {
    if (!giftVariant) return Promise.resolve();
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      setGiftAttribute(cart);
      var wanted = giftEligible ? giftWantedFor(cart) : 0;
      /* Keep at most the one gift this basket has earned; everything else goes. That
         covers the shopper moving between the two gifts as they add or remove the
         Protect capsules, and a basket that was handed several gift lines at once. */
      return dropUnwantedGifts(wanted).then(function () {
        if (!wanted) return;
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart2) {
          var line = giftLineIn(cart2);
          if (!line) return addGift(wanted);
          /* One gift per basket. A quantity posted straight to the cart is trimmed back. */
          if (line.item.quantity !== 1) return setLineQty(line.line, 1).then(giftMustBeFree);
          return giftMustBeFree();
        });
      });
    }).catch(function () {});
  }

  /* A basket change, and the gift sync that follows it, take about a second. A shopper
     who removed their subscription and hit Checkout inside that window used to reach
     checkout with the gift still in the basket - the gift was withdrawn a moment later,
     but the order had already been created. Checkout now waits for the basket to settle
     before it goes anywhere, on both the drawer link and the basket page button. */
  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('a[href="/checkout"], button[name="checkout"]');
    if (!go || go.getAttribute('data-settled') === '1') return;
    e.preventDefault();
    e.stopPropagation();
    go.setAttribute('aria-busy', 'true');
    go.style.opacity = '.6';
    go.style.pointerEvents = 'none';
    settleBasket().catch(function () {}).then(function () {
      go.setAttribute('data-settled', '1');
      go.removeAttribute('aria-busy');
      go.style.opacity = '';
      go.style.pointerEvents = '';
      if (go.tagName === 'A') window.location.href = go.getAttribute('href');
      else go.click();
    });
  }, true);

  window.CompleteCart = {
    /* properties, when passed, ride along as cart line properties. That is the only way
       to get a line of text into Shopify's checkout summary without a checkout app, which
       is what the free gift row needs - it has no product or variant behind it. */
    add: function (id, quantity, sellingPlan, properties) {
      var body = { items: [{ id: id, quantity: quantity || 1 }] };
      if (sellingPlan) body.items[0].selling_plan = sellingPlan;
      if (properties) body.items[0].properties = properties;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () { return settleBasket(); })
        .then(function () { fetchCart(); openCart(); });
    },
    /* Kept as the single entry point every Add to Basket button already calls. The
       basket no longer refuses any combination of plans, so this just forwards. */
    addGuarded: function (opts) {
      return this.add(opts.variantId, opts.quantity, opts.sellingPlan, opts.properties);
    },
    /* Lets the basket page settle the gift after its own updates. */
    settle: settleBasket,
    refresh: fetchCart
  };

  function openCart() {
    if (cartDrawer) cartDrawer.style.transform = 'translateX(0)';
    if (cartOverlay) { cartOverlay.style.opacity = '1'; cartOverlay.style.pointerEvents = 'auto'; }
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.style.transform = 'translateX(100%)';
    if (cartOverlay) { cartOverlay.style.opacity = '0'; cartOverlay.style.pointerEvents = 'none'; }
  }
  document.querySelectorAll('[data-cart-toggle]').forEach(function (b) { b.addEventListener('click', function () { fetchCart(); openCart(); }); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-close]')) closeCart();
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  if (cartBody || cartCountEls.length) syncGift().then(fetchCart);

  /* Video poster + first-frame priming (any <video> on the page) */
  function baseName(v) {
    var src = v.querySelector('source[src]');
    var s = (src && src.getAttribute('src')) || v.getAttribute('src') || v.currentSrc || '';
    s = s.split('#')[0].split('?')[0];
    try { s = decodeURIComponent(s); } catch (e) {}
    return s.split('/').pop().toLowerCase();
  }
  function showFrame(v) { try { if (!v.dataset.userPlayed && v.currentTime < 0.05) v.currentTime = 0.1; } catch (e) {} }
  function primeVideo(v) {
    if (v.dataset.framePrimed) return;
    if (!(v.currentSrc || v.querySelector('source[src]') || v.getAttribute('src'))) return;
    v.dataset.framePrimed = '1';
    if (!v.getAttribute('preload')) v.preload = 'metadata';
    v.setAttribute('playsinline', '');
    if (v.readyState >= 2) showFrame(v);
    else v.addEventListener('loadedmetadata', function () { showFrame(v); }, { once: true });
    v.addEventListener('play', function () { v.dataset.userPlayed = '1'; });
    v.addEventListener('ended', function () { v.dataset.userPlayed = ''; setTimeout(function () { showFrame(v); }, 0); });
  }
  function scanVideos() { document.querySelectorAll('video').forEach(primeVideo); }
  scanVideos();
  if ('MutationObserver' in window) new MutationObserver(scanVideos).observe(document.documentElement, { childList: true, subtree: true });
})();
